import React from 'react';
import * as S from './ErrorScreenStyles';
import { pushCtaOmniEvents } from '../../../../../config/omni';
import { MOB_CABS_HOB_LANDING, BOOK_ANOTHER_CAB_CLICKED, HOB_LANDING_PAGE, MOB_CABS_HOB_LISTING } from '../../../../../utils/util-constants';
import { CTA_TYPE } from '../../../../../utils/omni-utils';

const ErrorScreen = (props) => {
  const handleButtonClick = () => {
    pushCtaOmniEvents(`${props?.isListing ? MOB_CABS_HOB_LISTING : MOB_CABS_HOB_LANDING}_${BOOK_ANOTHER_CAB_CLICKED}`, CTA_TYPE.BUTTON, HOB_LANDING_PAGE, props?.cta?.giUrl)
    if (typeof window !== "undefined") {
      window.open(props?.cta?.giUrl, '_blank');
    }
  };

  return (
    <>
      <S.ErrorContainer>
        <S.ErrorImage src={props?.icon} />
        <S.ErrorTitle>{props?.title}</S.ErrorTitle>
        <S.ErrorMessage>{props?.message}</S.ErrorMessage>
      </S.ErrorContainer>
      <S.Container>
        <S.ButtonContainer onClick={handleButtonClick}>
          <S.ButtonTitle>{props?.cta?.text}</S.ButtonTitle>
        </S.ButtonContainer>
      </S.Container>
    </>
  );
};

export default ErrorScreen; 